import React, { useEffect, useState } from 'react';
import Button from '../../components/common/Button';
import FormField from '../../components/common/FormField';
import {
  PaymentDTO,
  PaymentResponseClient,
  PaymentResponseDTO,
  SearchRequestDTO_paymentResponseSearchRequestDTO,
} from '../../services/apiClient';
import usePaymentStatus from '../../hooks/usePaymentStatus';
import useCampaigns from '../../hooks/useCampaigns';
import { API_BASE_URL } from '../../config/config';
import axiosInstance from '../../services/axiosInstance';
import CollapsiblePanel from '../common/CollapsiblePanel';

interface PaymentFormProps {
  initialValues: PaymentDTO;
  onCancel: () => void;
}

const PaymentForm: React.FC<PaymentFormProps> = ({
  initialValues,
  onCancel,
}) => {
  const [formData, setFormData] = useState<PaymentDTO>(initialValues);
  const [logs, setLogs] = useState<PaymentResponseDTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const apiClient = new PaymentResponseClient(API_BASE_URL, axiosInstance);
  const fetchResponseLogs = async (filters = {}) => {
    const searchRequest: SearchRequestDTO_paymentResponseSearchRequestDTO = {
      filters: {
        ...filters,
        paymentId: formData.id,
      },
      page: 1,
      pageSize: 100,
      sortBy: 'CreatedUtc',
      sortDescending: true,
    };

    try {
      setIsLoading(true);
      const response = await apiClient.searchPaymentResponses(searchRequest);
      setLogs((response.data?.results as PaymentResponseDTO[]) || []);
    } catch (error) {
      console.error(`Error fetching Payments:`, error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (formData && formData.id) {
      fetchResponseLogs();
    }
  }, [formData.id]);

  const handleChange = (key: keyof PaymentDTO) => (value: string) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  return (
    <>
      <div className="mb-4">
        <FormField
          id="paymentStatusId"
          label="Status"
          type="text"
          value={formData.paymentStatusName || ''}
          onChange={(e) => handleChange('paymentStatusId')(e.target.value)}
          placeholder="Status"
          disabled
        />
        <FormField
          id="memberId"
          label="Member"
          type="text"
          value={formData.memberName || ''}
          onChange={(e) => handleChange('memberId')(e.target.value)}
          placeholder="Enter member"
          disabled
        />
        <FormField
          id="campaignId"
          label="Campaign"
          type="text"
          value={formData.campaignName || ''}
          onChange={(e) => handleChange('campaignId')(e.target.value)}
          placeholder="Campaign"
          disabled
        />
        <FormField
          id="amount"
          label="Amount"
          type="number"
          value={formData.amount || ''}
          onChange={(e) => handleChange('amount')(e.target.value)}
          placeholder="Enter Amount"
          disabled
        />
        {logs.map((log) => (
          <CollapsiblePanel
            key={log.id}
            title={log.paymentResponseTypeName ? `${log.paymentResponseTypeName} Response - Netcash` : 'Response'}
            collapsed={true}
          >
            <code className="block whitespace-pre-wrap break-words text-sm bg-gray-100 dark:bg-slate-800 text-emerald-700 dark:text-emerald-400 p-3 rounded-md font-mono">
              {JSON.stringify(JSON.parse(log.data || '{}'), null, 2)}
            </code>
          </CollapsiblePanel>
        ))}
      </div>
      <div className="flex justify-end space-x-4">
        <Button variant="secondary" onClick={onCancel}>
          Back
        </Button>
      </div>
    </>
  );
};

export default PaymentForm;
